export const sampleData = [
  { name: 'Document', icon: '/assets/Document.png',route: '/filelist'  },
  { name: 'Image', icon: '/assets/image.png', route:'/photos' },
  { name: 'Videos', icon: '/assets/video.png', route:'/videos'  },
  { name: 'Audio', icon: '/assets/Audio.png', route:'/audios' },
  { name: 'Others', icon: '/assets/video.png',  },
];